import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Lock } from "lucide-react";
import { CONTACT } from "@/data/content";
import { useLang } from "@/i18n";

export default function Footer() {
    const { t } = useLang();
    return (
        <footer data-testid="site-footer" className="bg-cb-darker text-white cb-grid">
            <div className="max-w-7xl mx-auto px-6 py-20 grid gap-12 md:grid-cols-4">
                <div className="md:col-span-2">
                    <div className="font-display text-3xl font-bold tracking-tight">
                        Gruppo <span className="text-cb-accent">CB</span> Srl
                    </div>
                    <p className="mt-4 max-w-sm text-slate-400 leading-relaxed">{t.footer.tagline}</p>
                    <a
                        href="/preventivo"
                        className="cb-glow inline-block mt-6 bg-cb-accent hover:bg-cb-accentHover text-white px-6 py-3 text-sm font-medium transition-colors"
                    >
                        {t.footer.quote}
                    </a>
                </div>

                <div>
                    <h4 className="text-sm uppercase tracking-[0.2em] text-slate-500 mb-5">{t.footer.nav}</h4>
                    <ul className="space-y-3 text-slate-300">
                        <li><Link to="/" className="hover:text-cb-accent transition-colors">{t.nav.home}</Link></li>
                        <li><Link to="/servizi" className="hover:text-cb-accent transition-colors">{t.nav.services}</Link></li>
                        <li><Link to="/progetti" className="hover:text-cb-accent transition-colors">{t.nav.projects}</Link></li>
                        <li><Link to="/squadra" className="hover:text-cb-accent transition-colors">{t.nav.team}</Link></li>
                        <li><Link to="/certificazioni" className="hover:text-cb-accent transition-colors">{t.nav.certifications}</Link></li>
                        <li><Link to="/conto-termico" className="hover:text-cb-accent transition-colors">{t.nav.contoTermico}</Link></li>
                        <li><Link to="/contatti" className="hover:text-cb-accent transition-colors">{t.nav.contact}</Link></li>
                    </ul>
                </div>

                <div>
                    <h4 className="text-sm uppercase tracking-[0.2em] text-slate-500 mb-5">{t.footer.contacts}</h4>
                    <ul className="space-y-4 text-slate-300 text-sm">
                        <li className="flex gap-3"><MapPin size={18} className="text-cb-accent shrink-0" strokeWidth={1.5} />{CONTACT.address}</li>
                        <li className="flex gap-3"><Phone size={18} className="text-cb-accent shrink-0" strokeWidth={1.5} />{CONTACT.phone} · {CONTACT.mobile}</li>
                        <li className="flex gap-3"><Mail size={18} className="text-cb-accent shrink-0" strokeWidth={1.5} />{CONTACT.emails[0]}</li>
                    </ul>
                </div>
            </div>
            <div className="border-t border-white/10">
                <div className="max-w-7xl mx-auto px-6 py-6 text-xs text-slate-500 flex flex-col sm:flex-row justify-between gap-2">
                    <span>© {new Date().getFullYear()} {CONTACT.company}. {t.footer.rights}</span>
                    <div className="flex items-center gap-4">
                        <Link
                            to="/tecnico/computo-canali"
                            data-testid="footer-tech-link"
                            className="text-slate-500 hover:text-cb-accent transition-colors inline-flex items-center gap-1.5"
                            title="Area riservata al team tecnico"
                        >
                            <Lock size={11} strokeWidth={2} /> Area Tecnica
                        </Link>
                        <span>P.IVA · San Martino in Colle (PG)</span>
                    </div>
                </div>
            </div>
        </footer>
    );
}
